import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import {
  GUEST_USER_STATE_REVOKED,
  REQUEST_SIZE_INTERNAL_SHARED_USERS,
} from '../../components/SocialButtons/Share/InternalShare/constants/share';

import { InvitationType } from '../../types/guestShare';

type InitialStateType = {
  isLoading: boolean;
  totalCount: number;
  page: number;
  invitationList: InvitationType[];
};

const initialState: InitialStateType = {
  isLoading: false,
  totalCount: 0,
  page: 1,
  invitationList: [],
};

/** https://immerjs.github.io/immer/update-patterns/ */
export const slice = createSlice({
  name: 'guestShare',
  initialState,
  reducers: {
    getInvitationListAction: (state, action: PayloadAction<{ videoId: string; isAddRequest: boolean }>) => {
      state.isLoading = true;

      if (action.payload) {
        return state;
      }

      return state;
    },
    addMockInvitationsAction: (state, action: PayloadAction<InvitationType[]>) => {
      state.invitationList.push(...action.payload);
      state.totalCount += action.payload.length;
      state.page = Math.ceil(state.totalCount / REQUEST_SIZE_INTERNAL_SHARED_USERS);
    },
    setInvitationListAction: (
      state,
      action: PayloadAction<{ totalCount: number; page: number; invitationList: InvitationType[] }>,
    ) => {
      state.totalCount = action.payload.totalCount;
      state.page = action.payload.page;
      state.invitationList = action.payload.invitationList;
      state.isLoading = false;
    },
    sendInvitationAction: (state) => state,
    revokeInvitationAction: (state, action: PayloadAction<{ invitationId: string }>) => {
      const user = state.invitationList.find(({ invitationId }) => invitationId === action.payload.invitationId);
      if (user) {
        user.state = GUEST_USER_STATE_REVOKED;
      }
    },
    clearAllAction: () => ({ ...initialState }), // Return a new copy of the initial state
  },
});

export const {
  getInvitationListAction,
  addMockInvitationsAction,
  setInvitationListAction,
  sendInvitationAction,
  revokeInvitationAction,
  clearAllAction,
} = slice.actions;
